<div *ngIf="registration != undefined" class="col">
	<div class="list-title d-flex">
		<span class="d-flex w-100 pr-1 title cursor-pointer" (click)="isCollapsed = !isCollapsed">
			{{ 'Registration determinants label' | translate }}
			<span class="list-header-collapse-toggle ml-auto">
				<i class="fa fa-angle-{{isCollapsed ? 'down' : 'up'}}"></i>
			</span>
		</span>
	</div>
	<div class="row expanded-list p-0" *ngIf="!isCollapsed">
		<div class="col list-item-container">
			<div class="list-item item first" (click)="initSectionData('mandatoryJsonDeterminants')">
				<span class="addon">
					<span class="label">{{'Mandatory for' | translate}}</span>
				</span>
				<div class="mandatory-for">
					<det-popover [extraClasses]="hasDeterminant(registration.mandatoryJsonDeterminants) ? 'active' : ''"
						[determinant]="registration.mandatoryJsonDeterminants"
						[noneSelectedText]="(hasDeterminant(registration.optionalJsonDeterminants) ? 'No-One' : 'All')"
						[placement]="'left'" showDeterminant="true"
						[hasErrors]="errors?.missing_determinants_in_registration_mandatory"
						[determinantMapById]="determinantMapById"></det-popover>
				</div>
			</div>
			<div class="list-item item last" (click)="initSectionData('optionalJsonDeterminants')">
				<span class="addon">
					<span class="label">{{'Optional for' | translate}}</span>
				</span>
				<div>
					<det-popover [extraClasses]="hasDeterminant(registration.optionalJsonDeterminants) ? 'active' : ''"
						[determinant]="registration.optionalJsonDeterminants" [noneSelectedText]="'None'"
						[placement]="'left'" showDeterminant="true"
						[hasErrors]="errors['missing_determinants_in_registration_optional']"
						[determinantMapById]="determinantMapById"></det-popover>
				</div>
			</div>
		</div>
	</div>
</div>